// extracted by mini-css-extract-plugin
export default {"warning":"sms-notification_warning__vlYcu","has-warning":"sms-notification_has-warning__b4qU2","link":"sms-notification_link__68xT1"};